export const SCHEDULEDJOB: {[key:string] : string } = {
    GBP_ACCOUNTS: 'GBP_ACCOUNTS',
    GBP_LOCATIONS: 'GBP_LOCATIONS',
    GBP_VERIFICATION_STATUS: 'GBP_VERIFICATION_STATUS',
    GBP_REVIEWS: 'GBP_REVIEWS',
    GBP_POSTS: 'GBP_POSTS',
    GBP_PERFORMANCE: 'GBP_PERFORMANCE',
    GBP_QUESTIONS: 'GBP_QUESTIONS',     // Deprecated 
  }